import { useMutation, useQueryClient } from "@tanstack/react-query";

import { requests } from "api";

import { EMPLOYEES_QUERY_KEY } from "./useEmployeesQuery";

export const useEditEmployeeMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: requests.legalCabinetGatewayEditUser.bind(requests),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: EMPLOYEES_QUERY_KEY })
  });
};
